module.exports = __webpack_public_path__ + "img/Komite-Audit-Armanto-Witjaksono.98252d46.jpg";